export default __webpack_public_path__ + "static/obi-0624341b0829a87bf5f17bf286372a59.jpg";